<n-slide-window *ngIf="pageReady"
    [(visible)]="windowVisible"
    [loading]="loading"
    [width]="SWITCH.IS_SIMPLE_MODE ? '6.08rem' : '7.5rem'"
    (onHide)="close()">
    <n-header>
        <h1>{{title}}</h1>
        <n-help-link key="cifsipAdd" *ngIf = "!SWITCH.IS_SIMPLE_MODE"></n-help-link>
    </n-header>

    <form [formGroup]="vm" [simpleMode]="SWITCH.IS_SIMPLE_MODE"
        [errorMessage]="errorMessage">
        <!-- IP地址/地址段 -->
        <n-form-item [label]="i18n.rules"
            required="true"
            [helpContent]="i18n.helpTip">
            <n-multi-input id="add-ip-white-list-rules"
                formControlName="rules"
                [nTooltip]="i18n.ipWhiteListTips"
                [seperator]="[',']"
                nTooltipTrigger="focus">
            </n-multi-input>
        </n-form-item>
    </form>

    <n-footer>
        <button id="add-ip-white-list-ok-btn"
            nButton
            theme="primary"
            [label]="i18n.okBtn"
            (click)="onOk()">
        </button>
        <button id="add-ip-white-list-cancel-btn"
            nButton
            [label]="i18n.cancelBtn"
            (click)="hide()">
        </button>
    </n-footer>
</n-slide-window>
